/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  autorizarPeriodoPagoIMSSDetalle,
  deletePeriodoPagoIMSSDetalle,
  getPeriodoPagoIMSSDetalle,
  getPeriodosPagoIMSSDetalle,
  patchPeriodoPagoIMSSDetalle,
  postPeriodoPagoIMSSDetalle,
} from 'api/catalogos/PeriodoPagosImssDetalle';
import moment from 'moment';
import { getConceptosPeriodosPagoSS } from 'api/catalogos/PeriodoPagosImss';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';

export const niveldeestudioPermission = {
  permissionModel: 'niveldeestudio',
  catalogsModels: [],
  tabsModels: [],
};

const CalendarioPagosIMSSDetalle = ({ parentId, permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [conceptosPeriodos, setConceptosPeriodoss] = useState([]);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPeriodosPagoIMSSDetalle({
      periodo_de_seguro_imss: parentId,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _periodosFiscales,
        _conceptosPeriodos,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getConceptosPeriodosPagoSS(),
        getPeriodosPagoIMSSDetalle({
          periodo_de_seguro_imss: parentId,
        }),

      ]);
      if (mounted) {
        setEstados(_estados);
        setPeriodosFiscales(_periodosFiscales);
        setConceptosPeriodoss(_conceptosPeriodos);
        setData(_data);
        setLoading(false);
      }
    };
    if (parentId) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
    }, [parentId]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const match = responseData || data.find((item) => item.id === key);
      const _periodoIMSSDetalle = await getPeriodoPagoIMSSDetalle(match.id);

      if (_periodoIMSSDetalle) {
        form.resetFields();

        const formattedData = formatReceived(_periodoIMSSDetalle);

        form.setFieldsValue({
          ...formattedData,
          fecha_inicial: formattedData.fecha_inicial ? moment(formattedData.fecha_inicial) : null,
          fecha_final: formattedData.fecha_final ? moment(formattedData.fecha_final) : null,
          // eslint-disable-next-line max-len
          fecha_limite_de_pago: formattedData.fecha_limite_de_pago ? moment(formattedData.fecha_limite_de_pago) : null,
        });

        setDisableFields(_periodoIMSSDetalle?.estados_globales !== ESTATUS_ACTIVO);
        setVisible(true);
      }
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchPeriodoPagoIMSSDetalle(key, values) : postPeriodoPagoIMSSDetalle(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePeriodoPagoIMSSDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData(record);
    form.setFieldsValue({
      ...record,
      fecha_inicial: record.fecha_inicial ? moment(record.fecha_inicial) : null,
      fecha_final: record.fecha_final ? moment(record.fecha_final) : null,
      // eslint-disable-next-line max-len
      fecha_limite_de_pago: record.fecha_limite_de_pago ? moment(record.fecha_limite_de_pago) : null,
    });
  };

  const handleKeyPress = (e) => {
    if (/\d/.test(e.key)) {
      e.preventDefault();
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Nivel de Estudios ya autorizado');
        return;
      }
      const saved = await autorizarPeriodoPagoIMSSDetalle(key);
      if (saved) {
        const _data = await getPeriodoPagoIMSSDetalle();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'No. Periodo',
      dataIndex: 'descripcion_no_periodo',
      key: 'descripcion_no_periodo',

      width: 120,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'descripcion_periodo',
      key: 'descripcion_periodo',
      width: 120,
      // eslint-disable-next-line max-len
      // render: (val) => (val && periodosFiscales ? periodosFiscales.find((item) => item.id === val)?.periodo : 'N/A'),
      // eslint-disable-next-line max-len
      // render: (val) => (val && conceptosPeriodos ? conceptosPeriodos.find((item) => item.id === val)?.periodicidad : 'N/A'),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 160,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 160,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'No. Días',
      dataIndex: 'no_de_dias',
      key: 'no_de_dias',
      width: 120,
    },
    {
      titleText: 'Fecha Límite de Pago',
      dataIndex: 'fecha_limite_de_pago',
      key: 'fecha_limite_de_pago',
      width: 180,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'periododeseguroimssdetalle', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Detalle de Periodo IMSS`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
            )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="no_de_periodos" label="No. Periodo" rules={[{ required: true }]}>
                  <Input type="number" min={1} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="periodo" label="Periodo" rules={[{ required: true }]}>
                  <Input type="number" min={1} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="fecha_inicial" label="Fecha Inicial" rules={[{ required: true }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="fecha_final" label="Fecha Final" rules={[{ required: true }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="no_de_dias" label="No. Días" rules={[{ required: true }]}>
                  <Input type="number" min={1} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>

                <Form.Item name="fecha_limite_de_pago" label="Fecha Límite de Pago" rules={[{ required: true }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                    disabled
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`¿Desea eliminar el periodo ${selectedData?.periodo || 'N/A'} con fecha inicial ${
            selectedData?.fecha_inicial ? moment(selectedData.fecha_inicial).format('DD/MM/YYYY') : 'N/A'
          } y fecha final ${
            selectedData?.fecha_final ? moment(selectedData.fecha_final).format('DD/MM/YYYY') : 'N/A'
          }?`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`¿Desea autorizar el periodo ${selectedData?.periodo || 'N/A'} con fecha inicial ${
            selectedData?.fecha_inicial ? moment(selectedData.fecha_inicial).format('DD/MM/YYYY') : 'N/A'
          } y fecha final ${
            selectedData?.fecha_final ? moment(selectedData.fecha_final).format('DD/MM/YYYY') : 'N/A'
          }?`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`¿Desea inactivar el periodo ${selectedData?.periodo || 'N/A'} con fecha inicial ${
            selectedData?.fecha_inicial ? moment(selectedData.fecha_inicial).format('DD/MM/YYYY') : 'N/A'
          } y fecha final ${
            selectedData?.fecha_final ? moment(selectedData.fecha_final).format('DD/MM/YYYY') : 'N/A'
          }?`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default CalendarioPagosIMSSDetalle;
